export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";